<template>
    <div class="Information">
        <div class="row">
            <div class="col col-md-4">
                <h4>Name</h4>
                <p>
                    <span class="bold">First Name: </span>
                    <StringEditor 
                        v-bind:old-value="ChildRecordData.Person.FirstName" 
                        v-bind:record-id="ChildRecordData.Person.Id" 
                        v-bind:edit-mode="EditMode" 
                        data-label="First Name" 
                        property-name="FirstName"
                        update-method="Core/Person/Update"
                        v-bind:required="true" />
                </p>
                <p>
                    <span class="bold">AKA: </span>
                    <StringEditor 
                        v-bind:old-value="ChildRecordData.Person.AKA" 
                        v-bind:record-id="ChildRecordData.Person.Id" 
                        v-bind:edit-mode="EditMode" 
                        data-label="AKA" 
                        property-name="AKA"
                        update-method="Core/Person/Update" 
                        v-bind:required="false" />
                </p>
                <p>
                    <span class="bold">Middle Name: </span>
                    <StringEditor 
                        v-bind:old-value="ChildRecordData.Person.MiddleName"
                        v-bind:record-id="ChildRecordData.Person.Id"
                        v-bind:edit-mode="EditMode"
                        data-label="Middle Name"
                        property-name="MiddleName"
                        update-method="Core/Person/Update" 
                        v-bind:required="false" />
                </p>
                <p>
                    <span class="bold">Last Name: </span>
                    <StringEditor 
                        v-bind:old-value="ChildRecordData.Person.LastName"
                        v-bind:record-id="ChildRecordData.Person.Id"
                        v-bind:edit-mode="EditMode"
                        data-label="Last Name"
                        property-name="LastName"
                        update-method="Core/Person/Update" 
                        required="true" />
                </p>
                <p>
                    <span class="bold">Suffix: </span>
                    <StringEditor 
                        v-bind:old-value="ChildRecordData.Person.Suffix"
                        v-bind:record-id="ChildRecordData.Person.Id"
                        v-bind:edit-mode="EditMode"
                        data-label="Suffix"
                        property-name="Suffix"
                        update-method="Core/Person/Update" 
                        required="false" />
                </p>
            </div>
            <div class="col col-md-4">
                <h4>Personal Info</h4>
                <p>
                    <span class="bold">DOB: </span>
                    <DateEditor 
                        v-bind:old-value="ChildRecordData.Person.DOB"
                        v-bind:record-id="ChildRecordData.Person.Id"
                        v-bind:edit-mode="EditMode"
                        data-label="DOB"
                        property-name="DOB"
                        update-method="Core/Person/Update" 
                        required="true" 
                        :global-update="true" />
                </p>
                <p>
                    <span class="bold">SSN: </span>
                    <StringEditor 
                        v-bind:old-value="ChildRecordData.Person.SSN"
                        v-bind:record-id="ChildRecordData.Person.Id"
                        v-bind:edit-mode="EditMode"
                        data-label="SSN"
                        property-name="SSN"
                        update-method="Core/Person/Update"  />
                </p>
            </div>
            <div class="col col-md-4">
                <h4>Demographics</h4>
                <p>
                    <span class="bold">Sex: </span>
                    <SelectEditor 
                        v-bind:old-value="ChildRecordData.Person.SexID"
                        v-bind:old-value-text="ChildRecordData.Person.Sex.Name"
                        v-bind:record-id="ChildRecordData.Person.Id"
                        v-bind:edit-mode="EditMode"
                        data-label="Sex"
                        property-name="SexID"
                        update-method="Core/Person/Update" 
                        required="true" 
                        v-bind:options="SexOptions" />
                </p>
                <p>
                    <span class="bold">Race: </span>
                    <SelectEditor 
                        v-bind:old-value="ChildRecordData.Person.RaceID"
                        v-bind:old-value-text="ChildRecordData.Person.Race.Name"
                        v-bind:record-id="ChildRecordData.Person.Id"
                        v-bind:edit-mode="EditMode"
                        data-label="Race"
                        property-name="RaceID"
                        update-method="Core/Person/Update" 
                        required="true" 
                        v-bind:options="RaceOptions" />
                </p>
                <p>
                    <span class="bold">Ethnicity: </span>
                    <SelectEditor 
                        v-bind:old-value="ChildRecordData.Person.EthnicityID"
                        v-bind:old-value-text="ChildRecordData.Person.Ethnicity.Name"
                        v-bind:record-id="ChildRecordData.Person.Id"
                        v-bind:edit-mode="EditMode"
                        data-label="Ethnicity"
                        property-name="EthnicityID"
                        update-method="Core/Person/Update" 
                        required="true" 
                        v-bind:options="EthnicityOptions" />
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col padding-top-md pointer" v-on:click="ToggleEditMode()">
                <font-awesome-icon :icon="['fa', 'edit']" />
                <span v-if="EditMode"> Edit Mode: ON</span>
                <span v-else> Edit Mode: OFF</span>
            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import StringEditor from '../../../Core/ItemEditors/StringEditor';
    import DateEditor from '../../../Core/ItemEditors/DateEditor';
    import SelectEditor from '../../../Core/ItemEditors/SelectEditor';
    import PersonEditor from '../../../Core/ItemEditors/PersonEditor';
    export default {
        props: [
            'ChildRecordData'
        ],
        data: function () {
            return {
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            ToggleEditMode() {
                this.EditMode = !this.EditMode;
            }
        },
        components: {
            StringEditor,
            DateEditor,
            SelectEditor,
            PersonEditor
        },
        mounted() {

        },
        computed: {
            SexOptions: function () {
                return this.$store.state.Options.Sexes;
            },
            RaceOptions: function () {
                return this.$store.state.Options.Races;
            },
            EthnicityOptions: function () {
                return this.$store.state.Options.Ethnicities;
            }
        }
    }
</script>

<style scoped>
</style>